import React from 'react';
import { MapPin, Phone, Mail, Award, Building2 } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-16 border-t border-slate-900" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-106">
          <div className="col-span-1 md:col-span-2" data-id="element-107">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-108">
              Viridia Analytics
            </h3>
            <p className="text-slate-400 max-w-md mb-6" data-id="element-109">
              Marketing Automation for Phoenix Home Service Businesses. We help
              local companies grow with data-driven strategies and automated
              systems.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-110">
              <div className="flex items-center gap-2 bg-slate-900 px-3 py-1.5 rounded-md border border-slate-800" data-id="element-111">
                <Award className="w-4 h-4 text-red-500" data-id="element-112" />
                <span className="text-xs font-medium text-slate-300" data-id="element-113">
                  Yelp Certified Partner
                </span>
              </div>
              <div className="flex items-center gap-2 bg-slate-900 px-3 py-1.5 rounded-md border border-slate-800" data-id="element-114">
                <Building2 className="w-4 h-4 text-emerald-500" data-id="element-115" />
                <span className="text-xs font-medium text-slate-300" data-id="element-116">
                  Phoenix Chamber Member
                </span>
              </div>
            </div>
          </div>

          <div data-id="element-117">
            <h4 className="text-white font-semibold mb-4" data-id="element-118">Contact</h4>
            <ul className="space-y-3 text-sm" data-id="element-119">
              <li className="flex items-center gap-2" data-id="element-120">
                <MapPin className="w-4 h-4 text-slate-500" data-id="element-121" />
                Phoenix, AZ
              </li>
              <li className="flex items-center gap-2" data-id="element-122">
                <Phone className="w-4 h-4 text-slate-500" data-id="element-123" />
                (602) 829-6179
              </li>
              <li className="flex items-center gap-2" data-id="element-124">
                <Mail className="w-4 h-4 text-slate-500" data-id="element-125" />
                info@viridiaanalytics.com
              </li>
            </ul>
          </div>

          <div data-id="element-126">
            <h4 className="text-white font-semibold mb-4" data-id="element-127">Legal</h4>
            <ul className="space-y-3 text-sm" data-id="element-128">
              <li data-id="element-129">
                <a href="#" className="hover:text-white transition-colors" data-id="element-130">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="hover:text-white transition-colors" data-id="element-132">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-900 text-center text-xs text-slate-600" data-id="element-133">
          © {new Date().getFullYear()} Viridia Analytics. All rights reserved.
        </div>
      </div>
    </footer>;
}